import styles from "./subScreenBackground.module.scss";

/** Дополнительные экраны (меню, профиль, справочные разделы): градиент #222 → лавандовый низ */
export function SubScreenBackground() {
  return (
    <div className={styles.root} aria-hidden>
      <div className={styles.gradientBase} />
    </div>
  );
}
